import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Query, Result } from "../../../../interfaces";
import { Adapter } from "../../../../shared/adapter";
import { RolesAdapter } from "../../../../adapter/roles-adapter";
import { FindRoles } from "../../../roles";

export const FETCH_DATA_ROLES_REQUEST = 'FETCH_DATA_ROLES_REQUEST';
export const FETCH_DATA_ROLES_SUCCESS = 'FETCH_DATA_ROLES_SUCCESS';
export const FETCH_DATA_ROLES_FAILURE = 'FETCH_DATA_ROLES_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDataRolesRequest = () => {
    return {
        type: FETCH_DATA_ROLES_REQUEST,
    };
};

const fetchDataRolesSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DATA_ROLES_SUCCESS,
        payload: data
    };
};

const fetchDataRolesFailure = (error: any) => {
    return {
        type: FETCH_DATA_ROLES_FAILURE,
        payload: error,
    };
};

export const find = (page: number, pageSize: number, query:Query) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDataRolesRequest());
        try {
            const response = await FindRoles();
            dispatch(fetchDataRolesSuccess(
                { 
                    meta : response.meta,
                    values : Adapter.from(response.data).to((value) => new RolesAdapter(value).adapt()) 
                }
            ));

        } catch (error: any) {
            dispatch(fetchDataRolesFailure(error.message));
        }
    };
};
